import { useState } from "react";
import { get_cdn_url, tool_map, use_store } from "../store";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faMask,
  faUpload,
  faUser,
  faUserHatTieMagnifyingGlass,
  faUserSecret,
} from "@fortawesome/pro-light-svg-icons";
import {
  faInstagram,
  faReddit,
  faSnapchat,
  faTiktok,
} from "@fortawesome/free-brands-svg-icons";
import { LoadingBox } from "./Loading";
import { ProfileList } from "./profile_analysis";
import { StoryViewer } from "./story_viewer";
import RedditAnalysis from "./reddit_analysis";
import UserNotFound from "./user_not_found";
import Button from "./button";
import "core-js/actual";
import Faces from "./faces";
import { faSparkles } from "@fortawesome/pro-solid-svg-icons";
import Modal from "./modal";

export default function Analysis() {
  const [username, set_username] = useState("");
  const [location, set_location] = useState("");
  const [uploaded_images, set_uploaded_images] = useState<string[]>([]);
  const [show_modal, set_show_modal] = useState(false);
  const {
    loading,
    start_loading,
    stop_loading,
    tool,
    account_analysis,
    refresh_analysis,
    get_load_time,
    t,
  } = use_store();

  const handle_submit = async () => {
    if (username.trim().replace("@", "")) {
      start_loading(get_load_time() * 4);
      try {
        await refresh_analysis(
          username.trim(),
          String(tool).endsWith("_stories"),
          !String(tool).endsWith("_stories"),
        );
        window.scrollTo(0, 564);
      } finally {
        stop_loading();
      }
    }
  };

  const handle_image_upload = (e: React.ChangeEvent<HTMLInputElement>) => {
    const files = e.target.files;
    if (files) {
      const file_readers: Promise<string>[] = [];
      for (let i = 0; i < files.length; i++) {
        const file = files[i];
        const reader_promise = new Promise<string>((resolve) => {
          const reader = new FileReader();
          reader.onloadend = () => {
            resolve(reader.result as string);
          };
          reader.readAsDataURL(file);
        });
        file_readers.push(reader_promise);
      }
      Promise.all(file_readers).then((results) => {
        set_uploaded_images((prev) => [...prev, ...results]);
      });
    }
  };

  const handle_investigate = () => {
    set_show_modal(true);
  };

  if (!tool) {
    return <p>Loading...</p>;
  }

  return (
    <div className="w-full flex flex-col items-center">
      {
        <>
          <img
            src={get_cdn_url(`/brands/${tool}.webp`)}
            className="mb-[20px] hidden sm:block"
            style={{
              width: tool === "dating_tracker" ? 76 : 48,
              height: 48,
            }}
          ></img>
          <div className="eyebrows w-full flex flex-row justify-start sm:justify-center items-center gap-[8px]">
            <img
              src={get_cdn_url(`/brands/${tool}.webp`)}
              className="block sm:hidden"
              style={{
                width: tool === "dating_tracker" ? 50 : 32,
                height: 32,
              }}
            ></img>
            <div className="">{String(tool).replaceAll("_", " ")} TOOL</div>
          </div>
          <div className="flex flex-row items-center justify-center w-full mt-[8px]">
            <p className="mtitle sm:text-center">
              {t(tool_map.filter((x) => x.tool === tool)[0].hero)}
              <span className="text-brand-2 mtitle">
                {" "}
                {t("100% anonymous and untraceable.")}
              </span>
            </p>
          </div>

          <div className="flex flex-col sm:flex-row justify-center w-full mt-[20px] sm:items-center items-start">
            <div className="text-center flex flex-row sm:flex-col items-center sm:gap-[8px] flex-1 flex-grow mb-[16px]">
              <FontAwesomeIcon
                icon={faUserHatTieMagnifyingGlass}
                className="text-[24px] text-brand-2"
              />
              <div className="smallt px-[18px]">{t("No Login Required")}</div>
            </div>
            <div className="h-[40px] w-[1px] bg-lines hidden sm:block"></div>
            <div className="text-center flex flex-row sm:flex-col items-center sm:gap-[8px] flex-1 flex-grow  mb-[16px]">
              <FontAwesomeIcon
                icon={faUser}
                className="text-[24px] text-brand-2"
              />
              <div className="smallt px-[18px]">
                {t("Just share the username")}
              </div>
            </div>
            <div className="h-[40px] w-[1px] bg-lines hidden sm:block"></div>
            <div className="text-center flex flex-row sm:flex-col items-center sm:gap-[8px] flex-1 flex-grow mb-[24px]">
              <FontAwesomeIcon
                icon={faMask}
                className="text-[24px] text-brand-2"
              />
              <div className="smallt px-[16px]">{t("100% untraceable")}</div>
            </div>
          </div>

          {!loading && tool !== "dating_tracker" ? (
            <div className="w-full max-w-[640px]">
              <div className="border-lines border-[1px] p-[4px] rounded-[4px] w-full flex flex-row items-center flex-start px-[16px] py-[12px] mb-[8px] bg-surface">
                <FontAwesomeIcon
                  icon={
                    tool === "reddit_red_flags"
                      ? faReddit
                      : String(tool).startsWith("instagram")
                        ? faInstagram
                        : String(tool).startsWith("tiktok")
                          ? faTiktok
                          : faSnapchat
                  }
                  className="text-[28px] text-secondary"
                />
                <div className="mx-[12px] h-[28px] w-[1px] bg-lines"></div>
                <input
                  placeholder={t("@username")}
                  className="outline-none w-full inputt bg-surface"
                  value={username}
                  onChange={(e) => {
                    set_username(e.target.value);
                  }}
                ></input>
              </div>
              <Button
                onClick={handle_submit}
                icon={
                  String(tool).endsWith("_stories") ? faUserSecret : faSparkles
                }
              >
                {t(tool_map.filter((x) => x.tool === tool)[0].cta)}
              </Button>
              <Faces></Faces>
            </div>
          ) : !loading && tool === "dating_tracker" ? (
            <div className="w-full max-w-[640px]">
              <div className="flex flex-col sm:flex-row gap-[8px] mb-[8px]">
                <input
                  placeholder={t("Select a location")}
                  className="flex-1 border-lines border-[1px] p-[4px] rounded-[4px] px-[16px] py-[12px] bg-surface outline-none inputt"
                  value={location}
                  onChange={(e) => set_location(e.target.value)}
                />
                <label className="flex-1 border-lines border-[1px] p-[4px] rounded-[4px] px-[16px] py-[12px] bg-surface cursor-pointer flex items-center justify-center gap-[8px]">
                  <FontAwesomeIcon
                    icon={faUpload}
                    className="text-primary text-[20px]"
                  />
                  <span className="inputt">{t("Upload Images")}</span>
                  <input
                    type="file"
                    multiple
                    accept="image/*"
                    className="hidden"
                    onChange={handle_image_upload}
                  />
                </label>
              </div>
              {uploaded_images.length > 0 && (
                <div className="flex flex-wrap gap-[8px] mb-[8px]">
                  {uploaded_images.map((img, index) => (
                    <div key={index} className="relative">
                      <img
                        src={img}
                        alt={`Upload ${index + 1}`}
                        className="w-[60px] h-[60px] object-cover rounded-[4px] border-[1px] border-lines"
                      />
                      <button
                        onClick={() => {
                          set_uploaded_images((prev) =>
                            prev.filter((_, i) => i !== index),
                          );
                        }}
                        className="absolute -top-[4px] -right-[4px] w-[16px] h-[16px] bg-red-500 text-white rounded-full text-[10px] flex items-center justify-center"
                      >
                        ×
                      </button>
                    </div>
                  ))}
                </div>
              )}
              <Button onClick={handle_investigate} icon={faSparkles}>
                {t("Investigate")}
              </Button>
              <Modal
                is_open={show_modal}
                on_close={() => set_show_modal(false)}
              >
                <div className="flex flex-col gap-[16px]">
                  <h2 className="bigt">{t("Feature Not Available Yet")}</h2>
                  <p className="smallt">
                    {t(
                      "This feature is not implemented yet. For early access, please email",
                    )}{" "}
                    <a
                      href="mailto:lola@lululoyal.com"
                      className="text-brand-2 underline"
                    >
                      lola@lululoyal.com
                    </a>
                  </p>
                  <Button onClick={() => set_show_modal(false)}>OK</Button>
                </div>
              </Modal>
            </div>
          ) : (
            <LoadingBox
              text=""
              username={username}
              mode={String(tool).endsWith("_stories") ? "stories" : "followers"}
            ></LoadingBox>
          )}
          <div className="h-[8px]"></div>
        </>
      }
      {account_analysis?.not_found ? (
        <>
          <div className="bg-lines mt-[88px] mb-[48px] h-[1px] w-full"></div>
          <UserNotFound username={username} />
        </>
      ) : account_analysis ? (
        tool === "reddit_red_flags" ? (
          <>
            <div className="bg-lines mt-[88px] mb-[48px] h-[1px] w-full"></div>
            <RedditAnalysis />
          </>
        ) : String(tool).endsWith("_stories") ? (
          <>
            <div className="bg-lines mt-[88px] mb-[48px] h-[1px] w-full"></div>
            <StoryViewer />
          </>
        ) : (
          <>
            <div className="bg-lines mt-[88px] mb-[48px] h-[1px] w-full"></div>
            <ProfileList role="following" />
          </>
        )
      ) : (
        <></>
      )}
    </div>
  );
}
